module.exports = __webpack_public_path__ + "img/toplogo.b0ebcae3.png";